<template>
  <transition name="c-message-fade">
    <div v-if="visible" class="c-message" :class="`c-message--${type}`" @click="close">
      <span class="c-message__text">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: "CMessage",
  props: {
    message: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "primary"
    },
    timeout: {
      type: Number,
      default: 6000
    }
  },
  data() {
    return {
      visible: false,
      timer: null
    };
  },
  mounted() {
    if (this.visible && this.timeout > 0) {
      this.timer = setTimeout(this.close, this.timeout);
    }
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
  },
  watch: {
    visible(val) {
      if (val && this.timeout > 0) {
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(this.close, this.timeout);
      }
    }
  },
  methods: {
    close() {
      this.visible = false;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>

<style scoped>
.c-message {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 240px;
  max-width: 80%;
  padding: 10px 18px;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  z-index: 9999;
  cursor: pointer;
  word-break: break-all;
}

.c-message__text {
  display: inline-block;
}

.c-message--primary { background-color: #323232; }
.c-message--success { background-color: #67c23a; }
.c-message--info    { background-color: #909399; }
.c-message--error   { background-color: #f56c6c; }

.c-message-fade-enter-active,
.c-message-fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.c-message-fade-enter,
.c-message-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -10px);
}
</style>